import type { IconData } from '@stacksjs/iconify-core'

export const webcamOff: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M39 44.31a4 4 0 0 1-.601.1c-3.342.285-8.332.59-14.4.59c-6.066 0-11.057-.305-14.398-.59c-2.43-.208-3.895-2.582-2.564-4.627c1.108-1.702 2.74-3.653 5.065-5.283\"/><path d=\"M31.5 37.368A17.9 17.9 0 0 1 24 39c-9.941 0-18-8.059-18-18c0-2.677.584-5.217 1.632-7.5M36.36 34.086A17.95 17.95 0 0 0 42 21c0-9.941-8.059-18-18-18a17.95 17.95 0 0 0-13.066 5.62\"/><path d=\"M27 32.622c-.959.247-1.964.378-3 .378c-6.627 0-12-5.373-12-12c0-1.036.131-2.041.378-3m19.827 11.757A11.97 11.97 0 0 0 36 21c0-6.627-5.373-12-12-12a11.97 11.97 0 0 0-8.81 3.852\"/><path d=\"M26.5 24.123a4 4 0 1 0-5.668-5.566M6 4l38 38\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default webcamOff
